import NotificationMixin from './NotificationMixin';

export default {
  methods: {
    async isValid() {
      const validators = this.forms.map((ref) => this.$refs[ref].$validator.validateAll());
      const validForms = await Promise.all(validators);

      const isValid = validForms.filter((bool) => bool === false).length === 0;

      if (!isValid) {
        this.notifyValidationError();
      }

      return isValid;
    },

    async validateAllChildForms(forms, showErrorNotification = true) {
      // Base components
      const components = forms.map((f) => this.$refs[f] || null);
      let childForms = [];

      // Get all child form names (ref names) and send them to validateForms()
      components.forEach(childComponent => {
        if (childComponent.$refs) {
          childForms = Object.keys(childComponent.$refs);
        }
      });

      return this.validateForms(forms, childForms);
    },

    /**
     * Validate forms
     * @param formRefs
     * @param childFormRefs
     * @param showErrorNotification
     * @returns boolean
     */
    async validateForms(formRefs, childFormRefs = [], showErrorNotification = true) {
      // Base components
      const forms = formRefs.map((f) => this.$refs[f] || null);
      let validated = true;

      forms.forEach((form) => {
        if (!form.$refs.form.validate()) {
          validated = false;
        }
      });

      if (!validated) {
        this.notifyMissingFields();
      }

      return validated;
    },
    addErrors(e, skipNotify = false) {
      if (!e.response.data.errors) {
        return;
      }

      const errorBag = Object.entries(e.response.data.errors)
        .map((errorBag) => {
          return {
            field: errorBag[0],
            msg: errorBag[1][0]
          };
        });

      const addErrorToForms = (component, forms, {field, msg}) => {
        const fieldName = field.split('.').pop();
        component.$validator.errors.add({
          field: fieldName,
          msg,
        });

        forms.forEach((ref) => {
          const child = component.$refs[ref];

          if (!child) {
            return true;
          }

          // Child forms
          const childForms = child.$data['forms'] || [];
          addErrorToForms(child, childForms, {field, msg});
        });
      };

      errorBag.forEach((error) => {
        addErrorToForms(this, this.forms || [], error);
      });

      if (e.response.status === 422 && !skipNotify) {
        this.notifyValidationError();
      }
    },
    notifyValidationError(errorMessage = null) {
      this.$vs.notify({
        color: "danger",
        title: "Error occurred",
        text: errorMessage || "There are errors in your form entry. Please check and try again",
        iconPack: "feather",
        icon: "icon-alert-circle",
        position: "top-right"
      });
    }
  },
};
